<script lang="ts" setup>
import AttentionTemplate from '~/components/templates/AttentionTemplate/AttentionTemplate.vue';

useAppMeta({
  title: 'ユーザー様向け注意喚起情報',
});
</script>

<template>
  <AttentionTemplate />
</template>
